import React, { useState, useEffect } from 'react';
import { AiOutlineSearch, AiOutlineLogout } from "react-icons/ai";
import { useHistory } from "react-router-dom";
import { MdOutlineNotificationsNone } from "react-icons/md";
import { CgEditContrast } from "react-icons/cg";
import { useMsal } from "@azure/msal-react";
import { getUserInfo } from "../../../service/userService";
const SearchPanel = () => {

    const { instance } = useMsal();
    const history = useHistory();
    const [dropDown, setDropDown] = useState(true);
    const [darkTheme, setDarkTheme] = useState(false);

    const DropdownToggle = () => {
        setDropDown(!dropDown)
    }

    const handleLogout = () => {
        instance.logoutRedirect({
            postLogoutRedirectUri: msalConfigAuthOptions.postLogoutRedirectUri,
        });
    };

    useEffect(() => {
        // Accessing scss variable "--background-color"
        // and "--text-color" using plain JavaScript
        // and changing the same according to the state of "darkTheme"
        //const root = document.documentElement;
        //root?.style.setProperty(
        //    "--theme-primary-color",
        //    darkTheme ? "#346a3d" : "#422afb"
        //);
    }, [darkTheme]);
    const getUserDetails = (item) => {
        var data = getUserInfo();
        if (data.User) {
            return data.User[item];
        }
    }
    return (<>
        <div className="searchPanel">
            <div className="searchInputWrapper d-none">
                <AiOutlineSearch size="18" />
                <input type="text" className="" placeholder="Search" />
            </div>
            {/*<CgEditContrast size="20" className="colorLight cursorPointer" onClick={() => setDarkTheme(!darkTheme)} />*/}
            <MdOutlineNotificationsNone size="20" className="colorLight cursorPointer d-none" />
            <div className="userName" onClick={DropdownToggle}>
                {getUserDetails('FirstName') && getUserDetails('FirstName').slice(0, 1)}{getUserDetails('LastName') && getUserDetails('LastName').slice(0, 1)}
                <div className={`panelDropdownProfile ${dropDown ? 'd-none' : ''}`}>
                    <div className="profileDropdownItem border-bottom-light profileDropdownName">
                        👋 {getUserDetails('FirstName')} {getUserDetails('LastName')}
                    </div>
                    {/*<div className="profileDropdownItem">*/}
                    {/*    Profile Settings*/}
                    {/*</div>*/}
                    {/*<div className="profileDropdownItem">*/}
                    {/*    Notification Settings*/}
                    {/*</div>*/}
                    <div className="profileDropdownItem LogoutDropdown border-top-light" onClick={handleLogout} >
                        <AiOutlineLogout size="18" /> Logout
                    </div>
                </div>
            </div>
        </div>
    </>)
}

export default SearchPanel;